var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"urgency-card my-1",class:_vm.addClassUrgency},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"dot me-2"}),_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.urgencyStatus))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }